export const trailingSlash = 'never';
